import React, { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'
import { Container, Content, Header, InfoSection, InfoRow, ActionButton } from './styles'
import { api } from '../../services/api'
import { format } from 'date-fns'

const PublicDocumentView = () => {
  const { id } = useParams<{ id: string }>()
  const [documentInfo, setDocumentInfo] = useState<any>(null)
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    const fetchDocument = async () => {
      try {
        const response = await api.get(`/documents/${id}`)
        setDocumentInfo(response.data)
      } catch (error) {
        console.error('Error fetching public document', error)
      } finally {
        setLoading(false)
      }
    }
    
    if (id) {
      fetchDocument()
    }
  }, [id])

  if (loading) {
    return (
      <Container>
        <p>Carregando informações...</p>
      </Container>
    )
  }

  if (!documentInfo) {
    return (
      <Container>
        <Content>
          <Header>
            <h2>Documento Não Encontrado</h2>
            <p>O documento que você está procurando não existe ou foi removido.</p>
          </Header>
        </Content>
      </Container>
    )
  }

  const getFormattedSize = (sizeInBytes: number) => {
    if (!sizeInBytes) return '0 B'
    const sizes = ['B', 'KB', 'MB', 'GB', 'TB']
    const i = Math.floor(Math.log(sizeInBytes) / Math.log(1024))
    return `${(sizeInBytes / Math.pow(1024, i)).toFixed(2)} ${sizes[i]}`
  }

  // Obter metadados: combinar valores preenchidos com o schema (para mostrar os vazios)
  let docMetadata = documentInfo.documentTypeWithData?.metadata || [];
  const schemaMetadata = documentInfo.documentTypeWithData?.documentType?.metadata || [];
  
  if (docMetadata.length === 0 && schemaMetadata.length > 0) {
     docMetadata = schemaMetadata.map((m: any) => ({ name: m.name, value: 'Não informado' }));
  }

  return (
    <Container>
      <Content>
        <Header>
          <h2>{documentInfo.name}</h2>
          <p>Validação de Documento Oficial</p>
        </Header>

        <InfoSection>
          <h3>Informações Gerais</h3>
          <InfoRow>
            <strong>Criador por:</strong>
            <span>{typeof documentInfo.owner === 'object' ? documentInfo.owner?.name : 'Sistema'}</span>
          </InfoRow>
          <InfoRow>
            <strong>Data de Inclusão:</strong>
            <span>{documentInfo.createdAt ? format(new Date(documentInfo.createdAt), 'dd/MM/yyyy HH:mm') : '-'}</span>
          </InfoRow>
          <InfoRow>
            <strong>Tamanho:</strong>
            <span>{getFormattedSize(documentInfo.size)}</span>
          </InfoRow>
          {documentInfo.documentTypeWithData?.documentType?.name && (
            <InfoRow>
              <strong>Tipo de Documento:</strong>
              <span>{documentInfo.documentTypeWithData.documentType.name}</span>
            </InfoRow>
          )}
        </InfoSection>

        {docMetadata.length > 0 && (
          <InfoSection>
            <h3>Metadados</h3>
            {docMetadata.map((meta: any, index: number) => (
              <InfoRow key={index}>
                <strong>{meta.name}:</strong>
                <span>{meta.value || 'Não informado'}</span>
              </InfoRow>
            ))}
          </InfoSection>
        )}

        <ActionButton href={`/document/${id}`} target="_blank" rel="noopener noreferrer">
          Acessar Arquivo Original (Requer Login)
        </ActionButton>
      </Content>
    </Container>
  )
}

export default PublicDocumentView
